import Link from "next/link";
import { Info } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { GLOSSARY, type GlossaryTermKey } from "@/lib/glossary";
import { cn } from "@/lib/utils";

/**
 * Wiederverwendbarer Begriff-mit-Erklärung-Baustein (backlog.md -> C14) - dieselbe
 * Info-Tooltip-Optik, die bisher in jeder Komponente einzeln von Hand nachgebaut wurde
 * (z. B. `reverse-dcf-card.tsx`), hier einmal zentral für Begriffe aus `lib/glossary.ts`.
 * Ersetzt NICHT die bestehenden KPI-Tooltips (`lib/kpi-config.ts`) oder bereits
 * handgeschriebene Komponenten-Tooltips - nur für neue Stellen gedacht, an denen ein
 * Glossar-Begriff bisher unerklärt auftaucht.
 */
export function GlossaryTerm({ termKey, className }: { termKey: GlossaryTermKey; className?: string }) {
  const entry = GLOSSARY[termKey];
  return (
    <span className={cn("inline-flex items-center gap-1", className)}>
      {entry.term}
      <Tooltip>
        <TooltipTrigger asChild>
          {/* Zugleich Link statt reinem Button (backlog.md -> "Glossar-Verlinkung direkt
              aus jedem KPI-Tooltip") - der Hover-Tooltip bleibt fuer die schnelle Erklaerung
              unveraendert, ein Klick fuehrt zusaetzlich zum vollen Glossar-Eintrag. Bewusst
              KEIN Link INNERHALB von TooltipContent (Radix-Tooltips sind fuer nicht-
              interaktiven Inhalt gedacht - der Mauszeiger verlaesst den Trigger oft, bevor
              ein Klick in der Bubble ankommt). */}
          <Link
            href={`/glossar#${termKey}`}
            aria-label={`Erklärung: ${entry.term}`}
            className="text-muted-foreground hover:text-ink"
          >
            <Info className="h-3.5 w-3.5" />
          </Link>
        </TooltipTrigger>
        <TooltipContent className="max-w-72">{entry.definition}</TooltipContent>
      </Tooltip>
    </span>
  );
}
